// extracted by mini-css-extract-plugin
module.exports = {"grid":"create-user-transaction-form_grid__1k5ej","userTransactionGrid":"create-user-transaction-form_userTransactionGrid__2BFes"};